// FILE: client/src/reducers/creditReducers.js
import * as C from "../constants/creditConstants";

export const creditListReducer = (state = { blocks: [] }, action) => {
  switch (action.type) {
    case C.CREDIT_LIST_REQUEST:
      return { loading: true, blocks: [] };
    case C.CREDIT_LIST_SUCCESS:
      return { loading: false, blocks: action.payload || [] };
    case C.CREDIT_LIST_FAIL:
      return { loading: false, error: action.payload, blocks: [] };
    default:
      return state;
  }
};

export const creditAdminListReducer = (state = { blocks: [] }, action) => {
  switch (action.type) {
    case C.CREDIT_ADMIN_LIST_REQUEST:
      return { loading: true, blocks: [] };
    case C.CREDIT_ADMIN_LIST_SUCCESS:
      return { loading: false, blocks: action.payload || [] };
    case C.CREDIT_ADMIN_LIST_FAIL:
      return { loading: false, error: action.payload, blocks: [] };
    default:
      return state;
  }
};

export const creditDetailsReducer = (state = { block: null }, action) => {
  switch (action.type) {
    case C.CREDIT_DETAILS_REQUEST:
      return { loading: true, block: null };
    case C.CREDIT_DETAILS_SUCCESS:
      return { loading: false, block: action.payload };
    case C.CREDIT_DETAILS_FAIL:
      return { loading: false, error: action.payload, block: null };
    default:
      return state;
  }
};

export const creditCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case C.CREDIT_CREATE_REQUEST:
      return { loading: true };
    case C.CREDIT_CREATE_SUCCESS:
      return { loading: false, success: true, block: action.payload };
    case C.CREDIT_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case C.CREDIT_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

export const creditUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case C.CREDIT_UPDATE_REQUEST:
      return { loading: true };
    case C.CREDIT_UPDATE_SUCCESS:
      return { loading: false, success: true, block: action.payload };
    case C.CREDIT_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case C.CREDIT_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const creditDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case C.CREDIT_DELETE_REQUEST:
      return { loading: true };
    case C.CREDIT_DELETE_SUCCESS:
      return { loading: false, success: true };
    case C.CREDIT_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case C.CREDIT_DELETE_RESET:
      return {};
    default:
      return state;
  }
};
